import { OperatorDescription } from "@v2/components/controls/FilterManager/types";

export const Operators = {
  EQ: {label: 'Equal to', operator: '='},
  NOTEQ: {label: 'Not Equal to', operator: '!='},
  IN: {label: 'In', operator: 'in'},
  NOTIN: {label: 'Not In', operator: 'notin'},
  GT: {label: 'Greater Than', operator: '>'},
  GTEQ: {label: 'Greater Than or Equal to', operator: '>='},
  LS: {label: 'Less Than', operator: '<'},
  LSEQ: {label: 'Less Than or Equal to', operator: '<='},
  START: {label: 'Starts with', operator: 'start'},
  END: {label: 'Ends with', operator: 'end'},
  CONTAINS: {label: 'Contains', operator: 'contains'},
  INCLUDE: {label: 'Includes', operator: 'include'},
  EXCLUDE: {label: 'Excludes', operator: 'exclude'}
};

const typeOperatorsMap: {types: string[], operators: OperatorDescription[]}[] = [
  {
    types: ['id', 'reference'],
    operators:  [Operators.EQ, Operators.NOTEQ, Operators.IN, Operators.NOTIN],
  },
  {
    types: ['double', 'int', 'currency', 'percent', 'time'],
    operators:  [
      Operators.EQ,
      Operators.NOTEQ,
      Operators.GT,
      Operators.GTEQ,
      Operators.LS,
      Operators.LSEQ,
      Operators.IN,
      Operators.NOTIN
    ],
  },
  {
    types: ['string', 'email', 'phone', 'textarea', 'url'],
    operators:  [
      Operators.EQ,
      Operators.NOTEQ,
      Operators.START,
      Operators.END,
      Operators.CONTAINS,
      Operators.IN,
      Operators.NOTIN
    ]
  },
  {
    types: ['date', 'datetime'],
    operators: [Operators.EQ, Operators.NOTEQ, Operators.GT, Operators.GTEQ, Operators.LS, Operators.LSEQ],
  },
  {
    types: ['picklist', 'enumeration'],
    operators: [Operators.EQ, Operators.NOTEQ, Operators.IN, Operators.NOTIN],
  },
  {
    types: ['multipicklist'],
    operators: [Operators.EQ, Operators.NOTEQ, Operators.INCLUDE, Operators.EXCLUDE],
  },
  {
    types: ['boolean'],
    operators: [Operators.EQ, Operators.NOTEQ],
  }
];

export const getOperatorsForType = (fieldType: string) => {
  const item = typeOperatorsMap.find((item) => item.types.includes(fieldType));
  return item?.operators || [];
}
